const video = document.getElementById('movie');

function changeVideo() {
  const src = window.innerWidth <= 767 ? '/cms/wp-content/themes/goldwin2024/assets/img/sustainability/grc/grc_sp.mp4' : '/cms/wp-content/themes/goldwin2024/assets/img/sustainability/grc/grc.mp4';

  // 現在の動画と違う時だけ切替
  if (video.dataset.src !== src) {
    video.innerHTML = `<source src="${src}" type="video/mp4">`;
    video.dataset.src = src;
    video.load();

    // autoplay対策
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {});
    }
  }
}

changeVideo();
window.addEventListener('resize', changeVideo);

const marquee = document.querySelector('.repair-marquee');
const footer = document.querySelector('.repair-footer');

function updateMarqueePosition() {
  const footerRect = footer.getBoundingClientRect();
  const windowHeight = window.innerHeight;

  if (footerRect.top < windowHeight) {
    // フッターが見えてきたら、マーキーをフッターの上に移動
    const overlap = windowHeight - footerRect.top;
    marquee.style.bottom = `${overlap}px`;
  } else {
    marquee.style.bottom = '0';
  }
}

window.addEventListener('scroll', updateMarqueePosition);
window.addEventListener('resize', updateMarqueePosition);
updateMarqueePosition();

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll('.parallax-item').forEach((el) => {
  const speed = el.dataset.speed;

  gsap.set(el, { opacity: 0 });

  const tween = gsap.to(el, {
    y: -speed,
    ease: 'none',
    paused: true, // 最初は動きを止めて
    scrollTrigger: {
      trigger: el,
      start: 'top bottom',
      end: 'bottom top',
      scrub: 2,
      onEnter: () => {
        gsap.to(el, {
          opacity: 1,
          duration: 0.6,
          delay: 0.6,
          onComplete: () => tween.play(),
          // フェードが終わったら動き出す
        });
      },
    },
  });
});
document.querySelectorAll('.parallax-container').forEach((container) => {
  const img = container.querySelector('.parallax-img');

  gsap.to(img, {
    yPercent: -20,
    ease: 'none',
    scrollTrigger: {
      trigger: container, // 枠（マスク）を検知
      start: 'top bottom', // 要素の上が画面の下端に来たら
      end: 'bottom top', // 要素の下が画面の上端を過ぎたら
      scrub: 2, // 慣性
    },
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.swiper', {
    speed: 400,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      // 768px以下の設定
      0: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      // 769px以上の設定
      1024: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
    },
  });
  // --- 特定のdata-slide-idへ移動 ---
  const targetId = 'nearest'; // 移動したいID

  // 指定したdata属性を持つスライドを探す
  const targetSlide = document.querySelector(`.swiper-slide[data-slide-id="${targetId}"]`);

  if (targetSlide) {
    const targetIndex = Array.from(swiper.slides).indexOf(targetSlide);

    if (targetIndex !== -1) {
      // 移動実行
      swiper.slideTo(targetIndex, 0);
    }
  } else {
    // archiveしかない場合の処理
    // 最後（最新のアーカイブ）を表示する
    const lastIndex = swiper.slides.length - 1;
    swiper.slideTo(lastIndex, 0);

    // 単に最初のスライドを表示するなら slideTo(0, 0)
  }
});

function repairfadeImages() {
  //contents fade
  const fadetargets = document.querySelectorAll('.js-repair-fade-only');
  const options = {
    root: null,
    rootMargin: '0px 0px',
    threshold: 0,
  };

  var perfEntries = performance.getEntriesByType('navigation');
  var type = null;
  perfEntries.forEach(function (pe) {
    // 読み込みタイプを取得
    type = pe.type;
  });

  let observer = new IntersectionObserver(callback, options);

  fadetargets.forEach((fadetarget2) => {
    observer.observe(fadetarget2);
  });

  function callback(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        observer.unobserve(entry.target);
      }
    });
  }
}

document.addEventListener(
  'DOMContentLoaded',
  function () {
    repairfadeImages();
  },
  false
);

document.addEventListener('DOMContentLoaded', () => {
  const grcLogoMovie = document.getElementById('logoMovieGrc');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        // 要素が画面内に入った（isIntersectingがtrue）かつ、まだ再生されていない場合
        if (entry.isIntersecting) {
          grcLogoMovie.play();
          // 一度再生を開始したら、再度監視する必要がない場合は監視を解除
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0, // 動画の0%が画面に入ったら実行
    }
  );

  observer.observe(grcLogoMovie);
});
